module.exports = __webpack_public_path__ + "static/media/logo-ayuda.c3b8e548.png";